import { createSlice } from '@reduxjs/toolkit'

import { RootState } from '../../../../store'

import { deleteCustomer } from './apiActions/deleteCustomer'
import { fetchCustomerList } from './apiActions/fetchCustomerList'
import { getCustomer } from './apiActions/getCustomer'
import { ICustomerState } from './ICustomer'
import { initialState } from './initialCustomerState'

export const customerSlice = createSlice({
  name: 'customer',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchCustomerList.fulfilled, (state, action) => {
      state.list = action.payload

      return state
    })
    builder.addCase(getCustomer.fulfilled, (state, action) => {
      if (!state.list) {
        state.list = [action.payload]

        return state
      }

      const customerIndex = state.list.findIndex(
        oneCustomer => oneCustomer.customerUuid === action.payload.customerUuid,
      )
      if (customerIndex === -1) {
        state.list.push(action.payload)
      } else {
        state.list[customerIndex] = action.payload
      }

      return state
    })
    builder.addCase(deleteCustomer.fulfilled, (state, action) => {
      if (!state.list) {
        return state
      }

      state.list = state.list.filter(
        customer => customer.customerUuid !== action.payload.customerUuid,
      )

      return state
    })
  },
})

export const customerStateSelector = (state: RootState): ICustomerState =>
  state.customerNew

export const customerListSelector = (state: RootState) =>
  customerStateSelector(state).list

export default customerSlice.reducer
